import React from 'react';
import { Segment, Button, Header, Icon } from 'semantic-ui-react';
import { Link } from 'react-router-dom';

const NotFound = () => {
    return (
        <Segment placeholder>
            <Header icon>
                <Icon name='search' />
                Oops - wir haben überall nachgeschaut, konnten das Gesuchte aber nicht finden...
            </Header>
            <Segment.Inline>
                <Button as={Link} to='/' primary>
                    Zurück zur Startseite
                </Button>
            </Segment.Inline>
        </Segment>
    );
};

export default NotFound;